<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col lg:flex-row">
    <div
      class="flex-2 mb-12 flex min-w-[60%] flex-col justify-between gap-8 lg:mb-0"
    >
      <div class="text-3xl font-normal">
        {{ t("careers.section.who_we_are.header") }}
      </div>

      <div class="text-base font-normal lg:max-w-lg">
        <strong class="font-normal md:font-bold">{{
          t("careers.section.who_we_are.description.first_paragraph")
        }}</strong>
      </div>
      <div class="text-base font-normal lg:max-w-lg">
        <i18n-t
          keypath="careers.section.who_we_are.description.second_paragraph.base"
          tag="div"
          class="font-normal"
        >
          <template #placeholder_0>
            <strong class="font-normal md:font-bold">{{
              t(
                "careers.section.who_we_are.description.second_paragraph.placeholder_0"
              )
            }}</strong>
          </template>
          <template #placeholder_1>
            <strong class="font-normal md:font-bold">{{
              t(
                "careers.section.who_we_are.description.second_paragraph.placeholder_1"
              )
            }}</strong>
          </template>
          <template #placeholder_2>
            <strong class="font-normal md:font-bold">{{
              t(
                "careers.section.who_we_are.description.second_paragraph.placeholder_2"
              )
            }}</strong>
          </template>
        </i18n-t>
      </div>
      <div
        class="flex min-h-[10rem] w-full flex-col justify-between lg:flex-row"
      >
        <div
          class="mb-4 flex min-w-[30%] flex-row items-center justify-start gap-2 rounded-[1rem] border border-neutral-200 p-4 pl-3 lg:min-h-[10rem] lg:flex-col lg:justify-center lg:p-1"
        >
          <div class="text-3xl font-bold text-orange-500 lg:text-4xl">
            {{ t("careers.section.who_we_are.cards.0.achievement") }}
          </div>
          <div
            class="text-balance text-base font-normal opacity-80 lg:max-w-36 lg:text-center"
          >
            {{ t("careers.section.who_we_are.cards.0.description") }}
          </div>
        </div>
        <div
          class="mb-4 flex min-w-[30%] flex-row items-center justify-start gap-2 rounded-[1rem] border border-neutral-200 p-4 pl-3 lg:min-h-[10rem] lg:flex-col lg:justify-center lg:p-1"
        >
          <div class="text-3xl font-bold text-orange-500 lg:text-4xl">
            {{ t("careers.section.who_we_are.cards.1.achievement") }}
          </div>
          <div
            class="text-balance text-base font-normal opacity-80 lg:max-w-36 lg:text-center"
          >
            {{ t("careers.section.who_we_are.cards.1.description") }}
          </div>
        </div>
        <div
          class="mb-4 flex min-w-[30%] flex-row items-center justify-start gap-2 rounded-[1rem] border border-neutral-200 p-4 pl-3 lg:min-h-[10rem] lg:flex-col lg:justify-center lg:p-1"
        >
          <div class="text-3xl font-bold text-orange-500 lg:text-4xl">
            {{ t("careers.section.who_we_are.cards.2.achievement") }}
          </div>
          <div
            class="text-balance text-base font-normal opacity-80 lg:max-w-24 lg:text-center"
          >
            {{ t("careers.section.who_we_are.cards.2.description") }}
          </div>
        </div>
      </div>
    </div>

    <div class="flex min-w-72 flex-1 items-center lg:ml-10 lg:min-w-96">
      <img
        class="mx-auto aspect-square w-full max-w-sm shrink rotate-3 rounded-[2rem] object-cover drop-shadow-lg"
        :src="`${S3_ASSETS_URL}/careers/hero-01.jpg`"
      >
    </div>
  </div>
</template>
